/// <reference path="../../app.definition.ts" />


function maskInput() {
    return function (input, pattern, replacement) {
        if (!input || !pattern || !replacement) return input;

        // Create a new regex from the pattern
        const regex = new RegExp(pattern, 'g');

        // Replace the matching parts with the replacement string
        return input.replace(regex, replacement);
    };

}

angular.module('eCareVault.common.filters').filter('maskInput', maskInput);
